/**
 * Rounds a number to the nearest 5.
 * @param {number} x Number to round. If null/not set, returns 0.
 * @returns Rounds to nearest 5. For example, roundNearest5(22) returns 20, but roundNearest5(23) returns 25.
 * Note- All precipitation values should be rounded to nearest 5.
 */
export const roundNearest5 = x => Math.round((x ?? 0) / 5) * 5;

/**
 * Formats a temperature to include a degree symbol.
 * @param {number} temperature Temperature to format. If null/not set, returns empty string as per reqs around missing data.
 * @returns Temperature with degree symbol. For example, formatTemperature(20) returns 20°
 */
export const formatTemperature = temperature => (temperature ? `${temperature}°` : '');

/**
 * Formats precipitation data to include a percentage symbol and rounds to the nearest 5.
 * @param {number} precipChance Precipitation data to format. If null/not set, returns empty string as per reqs around missing data.
 * @returns Chance of precipitation with percentage symbol, rounded to nearest 5. For example, formatPrecipChance(18) returns 20%
 * Note- All precipitation values should be rounded to nearest 5.
 */
export const formatPrecipChance = precipChance => {
  const rounded = roundNearest5(precipChance);

  return rounded !== undefined || rounded !== null ? `${rounded}%` : '';
};

/**
 * Formats precipitation type to begin with a capital letter.
 * @param {string} precipType Precipitation type to format. If null/not set, returns empty string as per reqs around missing data.
 * @returns Chance of precipitation with percentage symbol, rounded to nearest 5. For example, formatPrecipType("rain") returns Rain
 */
export const formatPrecipType = precipType => (precipType ? precipType[0].toUpperCase() + precipType.slice(1) : '');
